import { render } from "./NavigationTree.vue?vue&type=template&id=0acf3875"
import script from "./NavigationTree.vue?vue&type=script&lang=js"
export * from "./NavigationTree.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__